<!--
	描述：西瑞定制的添加/编辑设备弹窗
-->
<template>
	<dialogBody class="addDialogBody" @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			<p class="titleImg"><img :src="getResourcesByName('/multipleSelection/title.png')" alt="" /></p>&nbsp;&nbsp;&nbsp;&nbsp; {{title}}
		</template>
		<div class="box_div">
			<p class="addTitle">请输入设备名称:</p>
			<input type="text" v-model="deviceInfo.name" />
		</div>
		<!--<div class="box_div">
			<p class="addTitle" v-show="deviceInfo.no == undefined">请输入设备所属采集端ID:</p>
			<input type="number" v-show="deviceInfo.no == undefined" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" v-model="deviceInfo.serverId" min="1" />
		</div>-->
		<div class="box_div">
			<p class="addTitle" v-show="deviceInfo.no == undefined">请选择数据采集方式:</p>
			<singleSelection class="singleSelection" v-show="deviceInfo.no == undefined" :dataList="deviceCollectionTypeList" @checkItem="nowDeviceCollectionType = $event" :autoCheck="getAutoCheckSingle(deviceCollectionTypeList,nowDeviceCollectionType)"></singleSelection>
		</div>
		<div class="box_div">
			<p class="addTitle" v-show="deviceInfo.no == undefined">请选择设备系列:</p>
			<singleSelection class="singleSelection" v-show="deviceInfo.no == undefined" :dataList="nowGroup.next" @checkItem="nowTemplate = $event" :autoCheck="getAutoCheckSingle(nowGroup.next,nowTemplate)">
			</singleSelection>
		</div>
		<template v-if="['mantunsciUDP','mantunsciHTTP'].includes(nowDeviceCollectionType.value)">
			<div class="box_div">
				<p class="addTitle" v-show="deviceInfo.no == undefined">请选择设备子型号:</p>
				<singleSelection class="singleSelection" v-show="deviceInfo.no == undefined" :dataList="nowTemplate.next" @checkItem="nowSubseries = $event" :autoCheck="getAutoCheckSingle(nowTemplate.next,nowSubseries)">
				</singleSelection>
			</div>
			<div class="box_div">
				<p class="addTitle">请输入设备MAC地址:</p>
				<input type="text" v-model="serverInfo.mac" />
			</div>
			<div class="box_div">
				<p class="addTitle">请输入设备线路地址(1-30):</p>
				<input type="number" onkeyup="this.value=this.value.replace(/\D/g,'')" onafterpaste="this.value=this.value.replace(/\D/g,'')" v-model="serverInfo.point" max="30" min="1" />
			</div>
		</template>
		<template v-else-if="nowDeviceCollectionType.value == 'telecomIOT'">
			<div class="box_div">
				<p class="addTitle">请输入设备ID:</p>
				<input type="text" v-model="serverInfo.deviceId" />
			</div>
		</template>
	</dialogBody>
</template>

<script>
	import singleSelection from '@/components/module/selection/base/singleSelection.vue'
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {
			dialogBody,
			singleSelection
		},
		props: [],
		data() {
			return {
				title: '',
				callback: undefined,
				cancelCallBack: undefined,
				deviceCollectionTypeList: [{
					name: "曼顿UDP协议",
					value: "mantunsciUDP"
				}, {
					name: "曼顿Http协议",
					value: "mantunsciHTTP"
				}, {
					name: "电信NB",
					value: "telecomIOT"
				}],
				nowDeviceCollectionType: {},
				//设备模板树
				deviceTemplateTree: [{
					name: "西安西瑞",
					value: "西安西瑞",
					next: [{
						name: "Z3-T30",
						value: "Z3-T30",
						next: [{
							name: "UDP单相",
							value: "UDP单相"
						}, {
							name: "UDP三相",
							value: "UDP三相"
						}, {
							name: "HTTP单相",
							value: "HTTP单相"
						}, {
							name: "HTTP三相",
							value: "HTTP三相"
						}]
					}, {
						name: "Z3-JTY-GD",
						value: "Z3-JTY-GD",
						next: [{
							name: "Z3-JTY-GD",
							value: "Z3-JTY-GD"
						}]
					}]
				}],
				nowGroup: {},
				nowTemplate: {},
				nowSubseries: {},
				serverInfo: {
					point: 1,
					//http:187ED53183CC
					//udp:98CC4D202DE0
					mac: "",
					deviceId: ""
				},
				// 设备信息
				deviceInfo: {
					no: undefined,
					name: '',
					deviceGroup: "",
					deviceTemplate: "",
					deviceSubseries: "",
					serverId: 1,//所属采集端，和后台对应默认为1
				}
			}
		},
		computed: {
			getAutoCheckSingle() {
				return(list, item) => {
					if(list == undefined) {
						return -1
					}
					return list.findIndex(it => it.value == item.value)
				}
			},
			getResourcesByName() {
				return resourcesStore.getters.getResourcesByName
			}
		},
		created() {
			this.nowGroup = this.deviceTemplateTree[0]
			this.nowDeviceCollectionType = this.deviceCollectionTypeList[0]
		},
		watch: {
			nowGroup(nv, ov) {
				this.nowTemplate = nv.next[0]
			},
			nowTemplate(nv, ov) {
				this.nowSubseries = nv.next[0]
			},
			nowDeviceCollectionType(nv, ov) {
				console.log(nv.name)
				switch(nv.name) {
					case '电信NB':
						this.nowGroup.next = [{
							name: "Z3-JTY-GD",
							value: "Z3-JTY-GD",
							next: [{
								name: "Z3-JTY-GD",
								value: "Z3-JTY-GD"
							}]
						}]
						break;
					case '曼顿UDP协议':
						this.nowGroup.next = [{
							name: "Z3-T30",
							value: "Z3-T30",
							next: [{
								name: "UDP单相",
								value: "UDP单相"
							}, {
								name: "UDP三相",
								value: "UDP三相"
							}]
						}]
						break;
					case '曼顿Http协议':
						this.nowGroup.next = [{
							name: "Z3-T30",
							value: "Z3-T30",
							next: [{
							name: "HTTP单相",
							value: "HTTP单相"
						}, {
							name: "HTTP三相",
							value: "HTTP三相"
						}]
						}]
						break;
				}
			}
		},
		mounted() {},
		methods: {
			confirm() {
				if(this.callback != undefined) {
					if(isempty(this.deviceInfo.name)) {
						this.$dialogMethod.showMessage("设备名称不能为空!")
						return
					}
					this.deviceInfo.deviceGroup = this.nowGroup.value
					this.deviceInfo.deviceTemplate = this.nowTemplate.value
					this.deviceInfo.deviceSubseries = this.nowSubseries.value
					this.deviceInfo.deviceCollectionType = this.nowDeviceCollectionType.value
					//只拿需要的
					var info = {}
					switch(this.deviceInfo.deviceCollectionType) {
						case "mantunsciUDP":
						case "mantunsciHTTP":
							info.mac = this.serverInfo.mac
							info.point = this.serverInfo.point
							if(isempty(info.mac)) {
								this.$dialogMethod.showMessage("MAC地址不能为空!")
								return
							}
							break
						case "telecomIOT":
							info.deviceId = this.serverInfo.deviceId
							if(isempty(info.deviceId)) {
								this.$dialogMethod.showMessage("设备ID不能为空!")
								return
							}
							break
					}
					this.deviceInfo.serverInfo = info
					if(this.callback(this.deviceInfo) == false) {
						return
					}
				}
				this.close()
			},
			cancel() {
				if(this.cancelCallBack != undefined) {
					this.cancelCallBack()
				}
				this.close()
			},
			open(title, callback, cancelcallback) {
				this.title = title
				this.callback = callback
				this.cancelCallBack = cancelcallback
				this.$refs.body.open()
			},
			update(title, data, callback, cancelcallback) {
				this.title = title
				this.callback = callback
				this.cancelCallBack = cancelcallback
				var tag = JSON.parse(data.config.tag)
				this.deviceInfo = {
					no: data.bean.no,
					name: data.deviceName,
					serverId: data.config.serverId,
				}
				this.serverInfo = tag.serverInfo
				this.nowDeviceCollectionType = this.deviceCollectionTypeList.find(item => item.value == data.config
					.deviceCollectionType)
				this.$refs.body.open()
			},
			close() {
				this.$refs.body.close()
			},
			checkDeviceCollectionType(type) {
				this.$set(this.deviceInfo, 'deviceCollectionType', type)
				switch(type.template) {
					case "Z3-T30":
						this.$set(this.deviceInfo, 'deviceSubseries', this.devicePointTypeList[0].deviceSubseries)
						break
					case "http":

						break
					case "NB":
						break
				}
			}
		}
	}
</script>
<style>
	.addDialogBody {
		z-index: 200;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.addDialogBody>span {}
	
	.addDialogBody input {
		border: .01rem solid #A9A9A9;
		border-radius: .05rem;
		padding: .02rem .05rem;
		line-height: .35rem;
		width: 200px;
	}
	
	.addDialogBody .addTitle {
		padding: 5px 0;
		display: inline-block;
		width: calc(100% - 270px);
		text-align: right;
		margin-right: 12px;
	}
	
	.box_div {
		margin-bottom: 25px;
	}
	
	.addDialogBody .singleSelection {
		display: inline-block;
		width: 210px;
	}
	
	.addDialogBody .singleSelection p {
		padding: 10px 0 10px 10px;
	}
	
	.addDialogBody .selectionBody {
		border-radius: .05rem;
	}
	
	.singleSelection {
		height: 35px;
		padding-top: 5px;
	}
	
	.titleImg {
		display: inline-block;
		margin-top: -3px;
		position: absolute
	}
</style>